// appsActions.js
import { ADD_APP, UPDATE_APP, REMOVE_APP, INIT_APP } from './../types/appConstants'

export function initApp(items) {
  return {
    type: INIT_APP,
    payload: items
  }
}

export function addApp(item) {
  return {
    type: ADD_APP,
    payload: item
  }
}

export function updateApp(item) {
  return {
    type: UPDATE_APP,
    payload: item
  }
}

export function removeApp(item) {
  return {
    type: REMOVE_APP,
    payload: item
  }
}
